import React, { SVGProps } from "react";
import AdoraLogo from "./adoraLogo.svg";

type AdoraLogoProps = SVGProps<SVGSVGElement>;
const StyledAdoraLogo = AdoraLogo as unknown as React.FC<AdoraLogoProps>;

interface LogoProps {
  width?: string;
  fill?: string;
  opacity?: number;
}
const Logo: React.FC<LogoProps> = ({ width = "135px", fill, opacity = 1 }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <StyledAdoraLogo width={width} fill={fill} opacity={opacity} />
    </div>
  );
};

export default Logo;
